//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { routerConfig } from "../../routers";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import "./AddIpWhiltelist";
import { jhaDropdownMenuPanelStyles } from "../../styles/jha-dropdown-menu-panel";
@customElement("ip-whitelist-main-view")
export class IpWhitelistMainView extends routingMixin(LitElement) {
  static get is() {
    return "ip-whitelist-main-view";
  }
  static readonly styles = [jhaDropdownMenuPanelStyles, css`
    #ipMain {
      display: flex;
      flex-direction: column;
      padding: 24px;
      height: -webkit-fill-available;
    }
    #formCon {
      display: flex;
      flex-direction: row;
    }
    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }
    jha-table-header {
      width: 20vw;
    }
    jha-card {
      margin-top: 30px;
      flex: 1;
      width: -webkit-fill-available;
    }
  `];
  @property({ type: Array })
  ipData = [
    {
      businessUnit: "Business Unit 1",
      CIDRBlock: "text-here",
      portRange: "text-here",
      description: "text-here",
    },
    {
      businessUnit: "Business Unit 2",
      CIDRBlock: "text-here",
      portRange: "text-here",
      description: "text-here",
    },
    {
      businessUnit: "Business Unit 3",
      CIDRBlock: "text-here",
      portRange: "text-here",
      description: "text-here",
    },
  ];
  onAddIpClick() {
    const router = new Router(routerConfig);
    router.go("/ip-whitelist/add-ip-whitelist");
  }
  onEditClick() {
    const router = new Router(routerConfig);
    router.go("/ip-whitelist/add-ip-whitelist");
  }
  async onDeleteClick() {
    const result = await openJhftDialog({
      variant: "danger",
      title: "Delete IP Allowlist",
      message: "Are you sure you want to delete this IP allowlist entry? This action cannot be undone.",
      cancelLabel: "Cancel",
      confirmLabel: "Delete",
    });
    if (result !== "confirm") return;
  }
  render() {
    return html`
      <slot>
        <div id="ipMain">
          <div id="formCon">
            <h1>IP Allowlist</h1>
            <div style="flex:1;"></div>
            <jha-form-row>
              <jha-form-input outline label="Search"
              maxlength="256"
                ><span slot="input-left"
                  ><jha-icon-search></jha-icon-search></span
              ></jha-form-input>
              <jha-button
                data-auto-id="addIPWhitelistBtn"
                type="button"
                primary
                large
                @click=${this.onAddIpClick}
                ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add IP Allowlist</jha-button
              >
            </jha-form-row>
          </div>
          <jha-card>
            <jha-table>
              <jha-table-row>
                <jha-table-header>Business Unit</jha-table-header>
                <jha-table-header>CIDR Block</jha-table-header>
                <jha-table-header>Port Range</jha-table-header>
                <jha-table-header>Description</jha-table-header>
                <jha-table-header></jha-table-header>
              </jha-table-row>
              ${this.ipData.map(
      (item) => html`
                  <jha-table-row>
                    <jha-table-cell>${item.businessUnit}</jha-table-cell>
                    <jha-table-cell>${item.CIDRBlock}</jha-table-cell>
                    <jha-table-cell>${item.portRange}</jha-table-cell>
                    <jha-table-cell>${item.description}</jha-table-cell>
                    <jha-table-cell>
                      <jha-dropdown>
                        <jha-dropdown-toggle
                          data-auto-id="ipWhitelistDropdown"
                          slot="toggle"
                          tabindex="0"
                          aria-expanded="false"
                          aria-haspopup="true"
                          role="button"
                        >
                          <jha-icon-view-more></jha-icon-view-more>
                        </jha-dropdown-toggle>
                        <jha-dropdown-menu>
                          <jha-dropdown-menu-item
                            data-auto-id="editIPWhitelistBtn"
                            role="link"
                            @click=${this.onEditClick}
                          >
                            <a>Edit IP</a>
                          </jha-dropdown-menu-item>
                          <jha-dropdown-menu-item
                            data-auto-id="deleteIPWhitelistBtn"
                            role="link"
                            @click=${this.onDeleteClick}
                          >
                            <a>Delete IP</a>
                          </jha-dropdown-menu-item>
                        </jha-dropdown-menu>
                      </jha-dropdown>
                    </jha-table-cell>
                  </jha-table-row>
                `
    )}
            </jha-table>
          </jha-card>
        </div>
      </slot>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "ip-whitelist-main-view": IpWhitelistMainView;
  }
}